import styled from 'styled-components';

export const PrivacyContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  max-width: 800px;
  margin: 0 auto;
  padding: 64px 24px 96px;
  background: #f9f8f4;
  font-family: 'DM Sans', system-ui, sans-serif;
  color: #4a4a42;
  line-height: 1.65;

  @media (max-width: 768px) {
    padding: 48px 20px 64px;
  }
`;

export const Title = styled.h1`
  font-family: 'Playfair Display', Georgia, serif;
  font-weight: 500;
  font-size: clamp(32px, 4.5vw, 48px);
  letter-spacing: -0.02em;
  color: #1a1a18;
  text-align: center;
  width: 100%;
  margin-bottom: 32px;
`;

export const Subtitle = styled.h2`
  font-family: 'Playfair Display', Georgia, serif;
  font-size: 1.5rem;
  font-weight: 500;
  color: #1a1a18;
  margin: 2rem 0 1rem 0;
  border-bottom: 2px solid #e6e5de;
  padding-bottom: 0.5rem;
`;

export const Text = styled.p`
  font-size: 17px;
  color: #4a4a42;
  margin-bottom: 16px;
`;

export const BoldText = styled.span`
  font-weight: 600;
  color: #1a1a18;
`;

export const Email = styled.span`
  cursor: pointer;
  color: #e8854a;
  font-weight: 500;
  transition: color 0.2s ease;

  &:hover {
    color: #c56a35;
    text-decoration: underline;
  }
`;

export const Section = styled.section`
  width: 100%;
  margin-bottom: 1.5rem;
`;

export const List = styled.ul`
  margin: 1rem 0;
  padding-left: 1.5rem;
`;

export const ListItem = styled.li`
  font-size: 17px;
  color: #4a4a42;
  margin-bottom: 0.5rem;
  line-height: 1.6;
`;

export const LastUpdated = styled.p`
  font-size: 0.9rem;
  color: #8a8a80;
  font-style: italic;
  text-align: center;
  width: 100%;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e6e5de;
`;

export const ContactInfo = styled.div`
  background-color: #ffffff;
  border-left: 4px solid #e8854a;
  padding: 1rem;
  margin: 1rem 0;
  border-radius: 0 4px 4px 0;

  ${Text} {
    margin-bottom: 0.5rem;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
